// extracted by mini-css-extract-plugin
module.exports = {"cntloaderTable":"loader-table_cntloaderTable__1Ba6U","spin":"loader-table_spin__1Fqmc"};